import { CompassCardUI } from '@scale/compass-ui/types';
import {
  LinterCardShared,
  type LinterSchemaType,
  type LinterContext,
  LINTER,
} from '@scale/genai-compass-shared/cards/linter';
import LinterCardComponent from './LinterCardComponent';
import { faLaptopCode } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: LinterContext = {
  cardType: LINTER,
  linterNames: [],
  projectId: '',
  reviewLevel: undefined,
};

export const LinterCardInfo: CompassCardUI<LinterSchemaType> = {
  ...LinterCardShared,
  title: 'Run Linters',
  icon: 'shield-check',
  toolTip: 'Run selected linters on your tasks',
  defaultContext,
  legacyComponent: LinterCardComponent,
  button: {
    icon: faLaptopCode,
  },
};
